/**
 * m.dbg -- Matriset dbgService
 */
import angular from 'angular';
const dbgModule = angular.module('m.dbg', [])
    .factory('mDbg', mDbg);
export default dbgModule.name;
// Run this as an angular app config() function to set up
// configuration that can only be done during config phase.
configureDebugFeatures.$inject = ['$logProvider', '$compileProvider'];
export function configureDebugFeatures($logProvider, $compileProvider) {
    // Some debug/production guidance on https://docs.angularjs.org/guide/production
    if (!__DEBUG__) {
        $logProvider.debugEnabled(false);
        $compileProvider.debugInfoEnabled(false);
        return;
    }
    console.log('mDbg config phase setup: enabled due to __DEBUG__');
    $logProvider.debugEnabled(true);
    $compileProvider.debugInfoEnabled(true);
}
mDbg.$inject = ['$timeout'];
function mDbg($timeout) {
    function countWatches() {
        // http://stackoverflow.com/questions/18499909/how-to-count-total-number-of-watches-on-a-page
        // wherever ng-app is, f.e. html or body
        var root = angular.element(document.getElementsByTagName('html'));
        var watchers = [];
        var f = function (element) {
            angular.forEach(['$scope', '$isolateScope'], function (scopeProperty) {
                if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
                    angular.forEach(element.data()[scopeProperty].$$watchers, function (watcher) {
                        watchers.push(watcher);
                    });
                }
            });
            angular.forEach(element.children(), function (childElement) {
                f(angular.element(childElement));
            });
        };
        f(root);
        // Remove duplicate watchers
        var watchersWithoutDuplicates = [];
        angular.forEach(watchers, function (item) {
            if (watchersWithoutDuplicates.indexOf(item) < 0) {
                watchersWithoutDuplicates.push(item);
            }
        });
        return watchersWithoutDuplicates.length;
    }
    function setup($transitions) {
        $transitions.onError({}, function (transition) {
            // A global error handler for failed transitions.
            // This fires for some intentional cases, e.g. when the transition is redirected
            // in a hook so we'll just disable it by default.
            // console.error('State change failed: ', transition.error());
        });
        if (__DEBUG__) {
            console.log('mDbg run phase setup: enabled due to __DEBUG__');
            $transitions.onSuccess({}, function () {
                // Print angularjs watch count. Thousands is bad, and browsers may get sluggish
                $timeout(function () {
                    console.log(`Watch count: ${countWatches()}`);
                }, 2000);
            });
        }
    }
    return {
        countWatches: countWatches,
        setup: setup,
    };
}
